import React, { useState } from "react";
import { create } from "zustand";
import DataListStore from "../../store/DataListStore";
import ListViewV2 from "../App/DataListV2";
import { Button, Card, Space } from "antd";
import { ProCard, ProForm, ProFormText } from "@ant-design/pro-components";
import { UpdateStatusPengiriman } from "services/datalist/datalist-api";

const defaultDataStore = create(DataListStore);

const PengirimanPesanan = () => {
  const [inputText, setInputText] = useState("");
  const [scanCounter, setScanCounter] = useState(0);

  let user = localStorage.getItem("auth-id");
  const userObj = JSON.parse(user);

  const updateData = () => {
    const data = {
      noResi: inputText,
      user: userObj.firstName,
      action: "KIRIM",
    };
    UpdateStatusPengiriman(data).then((res) => {
      if (res.found && res.found > 0) {
        setScanCounter((prev) => prev + res.found);
      } else {
        alert(
          "Resi tidak ditemukan atau sudah diproses sebelumnya. Periksa Kembali."
        );
      }
    });
  };

  return (
    <ListViewV2
      viewId={"bcpacking"}
      store={defaultDataStore}
      hideFilter
      addExtraRender={() => {
        return (
          <ProCard
            style={{ marginBottom: 16 }}
            bordered
            title="Proses Pengiriman Pesanan"
            collapsible
          >
            <Space
              display="flex"
              direction="vertical"
              style={{ width: "100%" }}
            >
              <Card title="Scan Resi untuk konfirmasi pengiriman.">
                <div style={{ textAlign: "center" }}>
                  <ProForm autoFocusFirstInput submitter={false}>
                    <ProFormText
                      width={"md"}
                      fieldProps={{
                        size: "large",
                        style: { textAlign: "center" },
                        placeholder: "Scan Resi Disini",
                        autoFocus: true,
                        onKeyUp: (e) => {
                          if (e.key === "Enter") {
                            updateData();
                            setInputText("");
                          }
                        },
                        onChange: (e) => {
                          setInputText(e.target.value);
                        },
                        value: inputText,
                      }}
                    />
                    <Button
                      size="large"
                      onClick={() => {
                        updateData();
                        setInputText("");
                      }}
                    >
                      Search
                    </Button>
                  </ProForm>
                </div>
                <div style={{ marginTop: 16, textAlign: "center" }}>
                  <h2>Total Scan: {scanCounter}</h2>
                </div>
              </Card>
            </Space>
          </ProCard>
        );
      }}
    />
  );
};

export default PengirimanPesanan;
